<template>
  <div class="review">
    <HeadingDisplay
      title="Revise os valores para seu limite day trade"
      subtitle="Para que a reserva seja concluída no dia do vencimento da oferta, mantenha saldo disponível na sua Conta Digital."
    />
    <ContentDisplay
      class="review__content"
      content-aspect="outside"
      footer-type="link"
      footer-label="Política de alavancagem"
      @click="goToPolicy"
    >
      <template #content-block-1>
        <Heading :level="6">Limite Day Trade</Heading>
        <ListDisplay
          v-for="(item, index) in details"
          :key="index"
          class="review__list-item"
          :title="item.label"
          :value="item.value"
        />
      </template>
    </ContentDisplay>
    <Terms
      :is-open="isTermsOpen"
      @close="isTermsOpen = false"
      @confirm="termAccepted"
    />
    <ButtonContainer class="review__button-container">
      <template #button-primary>
        <ButtonPrimary
          label="Continuar"
          size="large"
          :loading="dataForm.isUpdatingLimits"
          @click="isTermsOpen = true"
        />
      </template>
    </ButtonContainer>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, ref, Ref } from 'vue';

import {
  HeadingDisplay,
  ContentDisplay,
  Heading,
  ListDisplay,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { Terms } from './components';

import { EMarginAllocationSteps } from '@/modules/trade/views/MarginAllocationV2/helpers';
import { IMarginAllocationPreviewV2 } from '@/modules/trade/services/margin-allocation';

interface IDataForm {
  balance: { formatted: string };
  drawdown: { formatted: string };
  drawdownPercentage: { formatted: string };
  isUpdatingLimits: boolean;
}

const marginAllocationPreview = inject(
  'marginAllocationPreview'
) as Ref<IMarginAllocationPreviewV2>;
const changeStep = inject('changeStep', (step: EMarginAllocationSteps) => ({
  step
}));
const fetchUpdateLimits = inject('fetchUpdateLimits', async () => ({}));

const dataForm = inject('dataForm') as Ref<IDataForm>;

const isTermsOpen = ref(false);

const details = computed(() => {
  return [
    {
      label: 'Saldo alocado',
      value: dataForm.value.balance.formatted
    },
    {
      label: 'Prejuízo máximo',
      value: dataForm.value.drawdown.formatted
    },
    {
      label: 'Percentual do prejuízo ',
      value: dataForm.value.drawdownPercentage.formatted
    }
  ];
});

function goToPolicy() {
  window.open(marginAllocationPreview.value.policyLink, '_blank');
}

async function termAccepted() {
  isTermsOpen.value = false;
  await fetchUpdateLimits();
  changeStep(EMarginAllocationSteps.DAY_TRADE);
}
</script>

<style lang="less" scoped>
.review {
  max-width: 524px;
  margin: 0 auto;
  padding: @size-spacing-x1000 @size-spacing-x400 0;

  &__content {
    margin-top: @size-spacing-x800;
    background-color: @background-tertiary;
    border: none;

    :deep(.footer-button__inner) {
      background-color: @background-tertiary;
    }
  }

  &__list-item {
    margin-top: @size-spacing-x350;

    &:first-of-type {
      margin-top: @size-spacing-x500;
    }
  }

  &__button-container {
    background-color: @background-secondary;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 20;
  }
}
</style>
